import {
	MENU_IS_ACTIVE,
	ACTIVE_MENU_ITEM,
	ACTIVE_MENU_ITEMS,
	SEARCH_IS_ACTIVE,
} from '../types';

import { updateObject } from '../utility';

const initialState = {
	isActive: false,
	activeMenuItems: [],
	dropDown: [],
	searchActive: false,
	viewport: null,
};

const changeMenuActive = (state, action) => {
	return updateObject(state, {
		isActive: action.isActive,
		searchActive: false,
		activeMenuItems: !action.isActive ? [] : state.activeMenuItems,
	});
};

const changeActiveMenuItems = (state, action) => {
	let activeMenuItems = action.activeMenuItem !== null && action.activeMenuItem !== undefined ? [
		...state.activeMenuItems.splice(0, action.level),
		action.activeMenuItem,
	] : action.activeMenuItems;

	if (!activeMenuItems) {
		activeMenuItems = [];
	}

	return updateObject(state, {
		isActive: action.isActive || activeMenuItems.length,
		searchActive: false,
		activeMenuItems,
	});
};

const changeSearchActive = (state, action) => {
	return updateObject(state, {
		isActive: false,
		activeMenuItems: [],
		searchActive: action.isActive,
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case MENU_IS_ACTIVE:
			return changeMenuActive(state, action);
		case ACTIVE_MENU_ITEM:
		case ACTIVE_MENU_ITEMS:
			return changeActiveMenuItems(state, action);
		case SEARCH_IS_ACTIVE:
			return changeSearchActive(state, action);
		default:
			return state;
	}
};

export default reducer;
